import { useCallback } from "react";
import type { RouterOutputs } from "~/services/offstreetApi/types";
import type { ConvergeError, ConvergeResponse } from "../../../../../@types/elavon";
import { CONVERGE_SCRIPT_URLS } from "../../paymentSdkUrls";
import { useScript } from "../useScript";

type UseElavonProps = {
	paymentSession?: RouterOutputs["paymentSession"]["createPaymentSessionPublic"]["session"];
};

export const useElavon = ({ paymentSession }: UseElavonProps) => {
	const isLive = paymentSession?.client?.isLive ?? false;
	const scriptUrl = isLive ? CONVERGE_SCRIPT_URLS.live : CONVERGE_SCRIPT_URLS.sandbox;

	const isReady = useScript(scriptUrl, {
		enabled: !!paymentSession,
		isReady: () => Boolean(window.PayWithConverge),
		logGroup: "ELAVON_SCRIPT_LOAD_ERROR",
	});

	const openLightbox = useCallback(
		(callbacks: {
			onApproval: (response: ConvergeResponse) => void;
			onDeclined: (response: ConvergeResponse) => void;
			onError: (error: ConvergeError) => void;
			onCancelled: () => void;
		}) => {
			if (!window.PayWithConverge || !paymentSession) {
				callbacks.onError({ errorCode: "NOT_LOADED", errorMessage: "Converge not loaded" });
				return;
			}

			window.PayWithConverge.open(
				{
					ssl_txn_auth_token: paymentSession.clientSecret,
				},
				callbacks,
			);
		},
		[paymentSession],
	);

	return { isReady, openLightbox };
};
